const PIVOT_SIZE = { width: 50, height: 6 };

export default {
  PIVOT_SIZE,
};
